import { Autocomplete, FormControlLabel, Grid, Switch, TextField } from "@mui/material"
import Button from "components/Button"
import { Formik } from "formik"
import { t } from "i18next"
import { storageValidationSchema } from "pages/systemadmin/pages/devices/components/validationSchema"
import React from "react"
import { useTranslation } from "react-i18next"

export const StorageForm = ({ onSubmit, editStorage, result, feedback, companyResult }) => {
  const { t } = useTranslation()
  const initialValues = editStorage
    ? editStorage
    : {
        companyId: null,
        name: "",
        maximumCapacity: 0,
        isActive: true,
        storageDescription: "",
        adress: ""
      }

  const editMode = editStorage ? true : false

  const handleSubmit = async (values, { resetForm }) => {
    const storageToCredate = {
      ...values
    }
    onSubmit(storageToCredate)
  }

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={storageValidationSchema}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item md={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Autocomplete
                    id="companyId"
                    options={companyResult.data}
                    getOptionLabel={(option) => (option.name ? option.name : "")}
                    value={companyResult.data.find((i) => i.id === values.companyId) || ""}
                    isOptionEqualToValue={(option, value) => {
                      return option.id === value.id
                    }}
                    onChange={(e, value) => {
                      setFieldValue("companyId", value?.id)
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("global.company", "Company")}
                        variant="outlined"
                        name="companyId"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.companyId && errors.companyId ? true : false}
                        helperText={
                          touched.companyId && errors.companyId
                            ? t("global.company_is_required", "Company is required")
                            : null
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="name"
                    label={t("global.name", "Name")}
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && errors.name ? true : false}
                    helperText={
                      touched.name && errors.name ? t("global.name_is_required", "Name is required") : null
                    }
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    type="number"
                    id="maximumCapacity"
                    label={t("sysadmin.max_quantity_in_stock", "Max quantity in stock")}
                    value={values.maximumCapacity}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.maximumCapacity && errors.maximumCapacity ? true : false}
                    helperText={
                      touched.maximumCapacity && errors.maximumCapacity ? errors.maximumCapacity : null
                    }
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        onChange={(item) => {
                          const checked = item.target.checked
                          setFieldValue("isActive", checked)
                        }}
                        checked={values.isActive}
                      />
                    }
                    label={t("global.active", "Active")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="storageDescription"
                    label={t("global.description", "Description")}
                    value={values.storageDescription}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.storageDescription && errors.storageDescription ? true : false}
                    helperText={
                      touched.storageDescription && errors.storageDescription
                        ? errors.storageDescription
                        : null
                    }
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    id="adress"
                    label={t("global.address", "Address")}
                    value={values.adress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.adress && errors.adress ? true : false}
                    helperText={touched.adress && errors.adress ? errors.adress : null}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-end"
            style={{ marginTop: "2rem" }}>
            <Button color="primary" type="submit" result={result} feedback={feedback}>
              {editMode ? t("global.save", "Save") : t("global.add", "Add")}
            </Button>
          </Grid>
        </form>
      )}
    </Formik>
  )
}
